// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file qf/quickfeed.proto (package qf, syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { CourseLogRequestSchema, CourseLogSchema, CourseRequestSchema, CourseSubmissionsSchema, EnrollmentRequestSchema, GroupRequestSchema, NotesRequestSchema, RebuildRequestSchema, RepositoriesSchema, RepositoryIssuesSchema, RepositoryRequestSchema, ReviewRequestSchema, SubmissionRequestSchema, VoidSchema } from "./requests_pb";
import { file_qf_requests } from "./requests_pb";
import type { AssignmentFeedbackSchema, AssignmentFeedbacksSchema, AssignmentsSchema, CourseSchema, CoursesSchema, EnrollmentSchema, EnrollmentsSchema, GradeSchema, GroupSchema, GroupsSchema, NoteSchema, NotesSchema, ReviewSchema, SubmissionSchema, SubmissionsSchema, UserSchema, UsersSchema } from "./types_pb";
import { file_qf_types } from "./types_pb";

/**
 * Describes the file qf/quickfeed.proto.
 */
export const file_qf_quickfeed: GenFile = /*@__PURE__*/
  fileDesc("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", [file_qf_requests, file_qf_types]);

/**
 * users //
 *
 * @generated from service qf.QuickFeedService
 */
export const QuickFeedService: GenService<{
  /**
   * @generated from rpc qf.QuickFeedService.GetUser
   */
  getUser: {
    methodKind: "unary";
    input: typeof VoidSchema;
    output: typeof UserSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.GetUsers
   */
  getUsers: {
    methodKind: "unary";
    input: typeof VoidSchema;
    output: typeof UsersSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.UpdateUser
   */
  updateUser: {
    methodKind: "unary";
    input: typeof UserSchema;
    output: typeof VoidSchema;
  },
  /**
   * GetGroup returns a group with the given group ID or user ID. Course ID is required.
   *
   * @generated from rpc qf.QuickFeedService.GetGroup
   */
  getGroup: {
    methodKind: "unary";
    input: typeof GroupRequestSchema;
    output: typeof GroupSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.GetGroupsByCourse
   */
  getGroupsByCourse: {
    methodKind: "unary";
    input: typeof CourseRequestSchema;
    output: typeof GroupsSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.CreateGroup
   */
  createGroup: {
    methodKind: "unary";
    input: typeof GroupSchema;
    output: typeof GroupSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.UpdateGroup
   */
  updateGroup: {
    methodKind: "unary";
    input: typeof GroupSchema;
    output: typeof GroupSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.DeleteGroup
   */
  deleteGroup: {
    methodKind: "unary";
    input: typeof GroupRequestSchema;
    output: typeof VoidSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.GetCourse
   */
  getCourse: {
    methodKind: "unary";
    input: typeof CourseRequestSchema;
    output: typeof CourseSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.GetCourses
   */
  getCourses: {
    methodKind: "unary";
    input: typeof VoidSchema;
    output: typeof CoursesSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.UpdateCourse
   */
  updateCourse: {
    methodKind: "unary";
    input: typeof CourseSchema;
    output: typeof VoidSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.UpdateCourseVisibility
   */
  updateCourseVisibility: {
    methodKind: "unary";
    input: typeof EnrollmentSchema;
    output: typeof VoidSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.GetAssignments
   */
  getAssignments: {
    methodKind: "unary";
    input: typeof CourseRequestSchema;
    output: typeof AssignmentsSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.UpdateAssignments
   */
  updateAssignments: {
    methodKind: "unary";
    input: typeof CourseRequestSchema;
    output: typeof RepositoryIssuesSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.GetEnrollments
   */
  getEnrollments: {
    methodKind: "unary";
    input: typeof EnrollmentRequestSchema;
    output: typeof EnrollmentsSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.CreateEnrollment
   */
  createEnrollment: {
    methodKind: "unary";
    input: typeof EnrollmentSchema;
    output: typeof VoidSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.UpdateEnrollments
   */
  updateEnrollments: {
    methodKind: "unary";
    input: typeof EnrollmentsSchema;
    output: typeof VoidSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.GetSubmission
   */
  getSubmission: {
    methodKind: "unary";
    input: typeof SubmissionRequestSchema;
    output: typeof SubmissionSchema;
  },
  /**
   * Get latest submissions for all course assignments for a user or a group.
   *
   * @generated from rpc qf.QuickFeedService.GetSubmissions
   */
  getSubmissions: {
    methodKind: "unary";
    input: typeof SubmissionRequestSchema;
    output: typeof SubmissionsSchema;
  },
  /**
   * Get lab submissions for every course user or every course group
   *
   * @generated from rpc qf.QuickFeedService.GetSubmissionsByCourse
   */
  getSubmissionsByCourse: {
    methodKind: "unary";
    input: typeof SubmissionRequestSchema;
    output: typeof CourseSubmissionsSchema;
  },
  /**
   * UpdateSubmission updates the submission specified in the Grade message.
   * If the Grade's UserID is zero, the grade is applied to all users associated with the submission.
   *
   * @generated from rpc qf.QuickFeedService.UpdateSubmission
   */
  updateSubmission: {
    methodKind: "unary";
    input: typeof GradeSchema;
    output: typeof VoidSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.RebuildSubmissions
   */
  rebuildSubmissions: {
    methodKind: "unary";
    input: typeof RebuildRequestSchema;
    output: typeof VoidSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.CreateReview
   */
  createReview: {
    methodKind: "unary";
    input: typeof ReviewRequestSchema;
    output: typeof ReviewSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.UpdateReview
   */
  updateReview: {
    methodKind: "unary";
    input: typeof ReviewRequestSchema;
    output: typeof ReviewSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.CreateNote
   */
  createNote: {
    methodKind: "unary";
    input: typeof NoteSchema;
    output: typeof NoteSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.UpdateNote
   */
  updateNote: {
    methodKind: "unary";
    input: typeof NoteSchema;
    output: typeof NoteSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.DeleteNote
   */
  deleteNote: {
    methodKind: "unary";
    input: typeof NoteSchema;
    output: typeof VoidSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.GetNotes
   */
  getNotes: {
    methodKind: "unary";
    input: typeof NotesRequestSchema;
    output: typeof NotesSchema;
  },
  /**
   * GetCourseNotes returns all internal notes for a course.
   *
   * @generated from rpc qf.QuickFeedService.GetCourseNotes
   */
  getCourseNotes: {
    methodKind: "unary";
    input: typeof CourseRequestSchema;
    output: typeof NotesSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.CreateAssignmentFeedback
   */
  createAssignmentFeedback: {
    methodKind: "unary";
    input: typeof AssignmentFeedbackSchema;
    output: typeof VoidSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.GetAssignmentFeedback
   */
  getAssignmentFeedback: {
    methodKind: "unary";
    input: typeof CourseRequestSchema;
    output: typeof AssignmentFeedbacksSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.CourseLogStream
   */
  courseLogStream: {
    methodKind: "server_streaming";
    input: typeof CourseLogRequestSchema;
    output: typeof CourseLogSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.GetRepositories
   */
  getRepositories: {
    methodKind: "unary";
    input: typeof CourseRequestSchema;
    output: typeof RepositoriesSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.IsEmptyRepo
   */
  isEmptyRepo: {
    methodKind: "unary";
    input: typeof RepositoryRequestSchema;
    output: typeof VoidSchema;
  },
  /**
   * @generated from rpc qf.QuickFeedService.SubmissionStream
   */
  submissionStream: {
    methodKind: "server_streaming";
    input: typeof VoidSchema;
    output: typeof SubmissionSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_qf_quickfeed, 0);

